import styled from 'styled-components';
import { getTextType, px2rem, mq, getSpace } from '../../../stylesheets/tools';

const StyledDateHeader = styled.div`
  .dateHeader_Bar {
    display: flex;
    justify-content: space-between;
    height: ${px2rem('49px')};
    ${mq('m')} {
      height: ${px2rem('59px')};
    }
    align-items: center;
    background: linear-gradient(
        222deg,
        transparent 7px,
        ${props => props.theme.siteTheme.primary} 0
      )
      top left;

    .dateHeader__dateWrapper {
      display: flex;
      flex-flow: row;
      align-items: center;
    }

    .dateHeader_indicator {
      display: flex;
      position: relative;
      width: ${px2rem('68px')};
      height: ${px2rem('67px')};

      ${mq('m')} {
        width: ${px2rem('78px')};
        height: ${px2rem('77px')};
      }
      justify-content: center;
      align-items: center;
      margin-left: ${getSpace('xxs')};

      span {
        position: absolute;
        width: 100%;
        text-align: center;
        ${getTextType('teaser')};
      }
    }
    .dateHeader__datelabel {
      ${getTextType('subline')};
      margin-left: ${getSpace('xs')};
    }
    .dateHeader__close {
      cursor: pointer;
      margin-right: 20px;
    }
  }
`;

export default StyledDateHeader;
